<template>
    <div>
        <b-row>
            <b-col cols="12" md="4">
                <b-form-group label="Codice Fiscale Assistito">
                    <b-form-input v-model="jsonData.codiceFiscaleAssistito" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="Codice Fiscale Operatore">
                    <b-form-input v-model="jsonData.codiceFiscaleOperatore" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="Codice ASL">
                    <b-form-select v-model="jsonData.codiceAsl" :options="opzioniAsl" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group label="Tipo Operatore">
                    <b-form-select v-model="tipoOperatoreSelezionato" :options="opzioniTipoOperatore" @change="onCambiaTipoOperatore" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="4">
                <b-form-group label="Codice Accesso">
                    <b-form-input v-model="jsonData.codiceAccesso" placeholder="Identificativo univoco dell'accesso" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="idPai">
                    <b-form-input v-model="jsonData.idPai" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="idPei">
                    <b-form-input v-model="jsonData.idPei" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group label="Tipo Accesso (codice / descrizione)">
                    <b-input-group>
                        <b-form-input v-model="jsonData.tipoAccessoCode" placeholder="es. ORD" />
                        <b-form-input v-model="jsonData.tipoAccessoDisplay" placeholder="es. Accesso ordinario" />
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group label="Tipo Gestione (codice / descrizione)">
                    <b-input-group>
                        <b-form-input v-model="jsonData.tipoGestioneCode" placeholder="es. DIR" />
                        <b-form-input v-model="jsonData.tipoGestioneDisplay" placeholder="es. Gestione diretta" />
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group label="Data/Ora Inizio">
                    <date-picker format="DD/MM/YYYY HH:mm" value-type="date" type="datetime" v-model="dataOraInizio"></date-picker>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group label="Data/Ora Fine">
                    <date-picker format="DD/MM/YYYY HH:mm" value-type="date" type="datetime" v-model="dataOraFine"></date-picker>
                </b-form-group>
            </b-col>
        </b-row>

        <hr class="sa-hr" />
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h5 class="mb-0">Prestazioni erogate</h5>
            <b-button size="sm" variant="outline-success" @click="onAddPrestazione">
                <b-icon icon="plus"></b-icon>
                Aggiungi prestazione
            </b-button>
        </div>
        <b-row v-for="(pr, index) in jsonData.prestazioni" :key="index" class="mb-2 align-items-center">
            <b-col cols="12" md="3">
                <b-form-input v-model="pr.codicePrestazione" placeholder="Codice prestazione" />
            </b-col>
            <b-col cols="12" md="6">
                <b-form-input v-model="pr.descrizionePrestazione" placeholder="Descrizione" />
            </b-col>
            <b-col cols="12" md="2">
                <b-form-input v-model="pr.note" placeholder="Note" />
            </b-col>
            <b-col cols="12" md="1">
                <b-button size="sm" variant="outline-danger" @click="onRemovePrestazione(index)">
                    <b-icon icon="trash"></b-icon>
                </b-button>
            </b-col>
        </b-row>
        <div v-if="!jsonData.prestazioni.length" class="text-muted">Nessuna prestazione aggiunta</div>

        <hr class="sa-hr" />
        <b-button variant="success btn-toolbar float-sm-right" @click="onClickSalva">
            <b-icon icon="check2"></b-icon>
            Registra Erogazione
        </b-button>
    </div>
</template>

<script>
import AndiamoMixin from "../mixins/AndiamoMixin";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
    components: { DatePicker },
    mixins: [AndiamoMixin],
    data() {
        return {
            dataOraInizio: null,
            dataOraFine: null,
            opzioniAsl: [
                { value: "150204", text: "150204" },
                { value: "150205", text: "150205" },
                { value: "150206", text: "150206" },
            ],
            tipoOperatoreSelezionato: null,
            // CONFERMATO dal CodeSystem reale tipoOperatore fornito da AnDIamo.
            opzioniTipoOperatore: [
                { value: "1", text: "1 - MMG" },
                { value: "2", text: "2 - PLS" },
                { value: "3", text: "3 - Infermiere" },
                { value: "4", text: "4 - Medico specialista" },
                { value: "5", text: "5 - Medico esperto in cure palliative" },
                { value: "6", text: "6 - Continuità assistenziale" },
                { value: "7", text: "7 - Psicologo" },
                { value: "8", text: "8 - Fisioterapista" },
                { value: "9", text: "9 - Logopedista" },
                { value: "10", text: "10 - OSS" },
                { value: "11", text: "11 - Dietista" },
                { value: "12", text: "12 - Assistente sociale del SSN" },
                { value: "13", text: "13 - Terapista occupazionale" },
                { value: "99", text: "99 - Altro" },
            ],
            jsonData: {
                codiceFiscaleAssistito: "",
                codiceFiscaleOperatore: "",
                tipoOperatoreCode: "",
                tipoOperatoreDisplay: "",
                codiceAccesso: "",
                codiceAsl: "150205",
                tipoAccessoCode: "",
                tipoAccessoDisplay: "",
                tipoGestioneCode: "",
                tipoGestioneDisplay: "",
                idPai: "",
                idPei: "",
                prestazioni: [],
            },
        };
    },
    methods: {
        onCambiaTipoOperatore(value) {
            let opzione = this.opzioniTipoOperatore.find((o) => o.value === value);
            this.jsonData.tipoOperatoreCode = value;
            this.jsonData.tipoOperatoreDisplay = opzione ? opzione.text.split(" - ")[1] : "";
        },
        onAddPrestazione() {
            this.jsonData.prestazioni.push({ codicePrestazione: "", descrizionePrestazione: "", note: "" });
        },
        onRemovePrestazione(index) {
            this.jsonData.prestazioni.splice(index, 1);
        },
        onClickSalva() {
            if (!this.jsonData.codiceAccesso || !this.jsonData.codiceFiscaleAssistito) {
                this.$bvToast.toast("Codice Accesso e Codice Fiscale Assistito sono obbligatori", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            if (!this.dataOraInizio || !this.dataOraFine) {
                this.$bvToast.toast("Data/Ora Inizio e Fine sono obbligatorie", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            // FHIR (Encounter.period) richiede ISO-8601 con offset (es.
            // "2026-09-23T09:00:00+02:00"): il backend fa un pass-through
            // diretto di questi due campi dentro il Bundle, senza parsing ne'
            // riformattazione, quindi la conversione va fatta qui, non
            // affidata al formato di visualizzazione del date-picker
            // (DD/MM/YYYY HH:mm), che non e' valido FHIR.
            this.jsonData.dataOraInizio = moment(this.dataOraInizio).format();
            this.jsonData.dataOraFine = moment(this.dataOraFine).format();
            this.andiamoInviaErogazione(this.jsonData, this.onSalvaSuccess);
        },
        onSalvaSuccess(response) {
            this.andiamoInviaErogazioneSuccess(response);
            this.$router.push("/andiamo/erogazioni");
        },
    },
};
</script>

<style scoped></style>
